// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxTemplate_wrapper__4OeVG","title":"BoxTemplate_title__2ZOs8","icon":"BoxTemplate_icon__1uGxH","content":"BoxTemplate_content__27YnE"};